import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { integrationProps } from '../src/helpers/integration/integrationProps';

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        ns: ['translation', 'userErrors', 'notifications', 'public', 'systemErrors'],
        defaultNS: 'translation',
        fallbackLng: 'en',
        lng: 'en',
        debug: false,
        react: {
            bindI18n: 'languageChanged',
            bindI18nStore: '',
            transEmptyNodeValue: '',
            transSupportBasicHtmlNodes: true,
            transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
            useSuspense: true,
        },
        backend: {
            loadPath: () => {
                return (integrationProps.getEndpointUrl() ? integrationProps.getEndpointUrl().origin : '') + '/locales/{{lng}}/{{ns}}.json';
            },
        }
    });

export default i18n;
